<div class="register-complete-container">
    <div *ngIf="percentage >= 100">
        <mat-icon class="">check</mat-icon>
        <p>Tu solicitud fue generada con éxito.
        Revisá tu correo donde te estaremos notificando el estado de tu solicitud
        </p>
    </div>
    <app-progress-bar  [percentage]="percentage" *ngIf="percentage < 100" ></app-progress-bar>
</div>
